export default __webpack_public_path__ + "static/media/fb-token-expired.49d1e1a9.png";